import React, { useEffect } from 'react';

const PreventIOSZoom = () => {
  useEffect(() => {
    // Prevent zooming on iOS
    const preventZoom = (event) => {
      // Prevent pinch zoom
      if (event.touches.length > 1) {
        event.preventDefault();
      }
      
      // Prevent double-tap zoom
    
      if (event.type === 'touchend' && event.touches.length === 0) {
        const now = new Date().getTime();
        const lastTouch = parseInt(event.target.dataset.lastTouch || '0', 10);
        
        if (now - lastTouch < 300) {
          event.preventDefault();
        }
        
        event.target.dataset.lastTouch = now.toString();
      }
    };

    // Add meta viewport tag to prevent scaling
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    document.head.appendChild(metaViewport);

    // Add event listeners
    document.addEventListener('touchstart', preventZoom, { passive: false });
    document.addEventListener('touchmove', preventZoom, { passive: false });
    document.addEventListener('touchend', preventZoom, { passive: false });

    // CSS to help prevent unexpected scrolling
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      html, body {
        position: fixed;
        overflow: hidden;
        overscroll-behavior: none;
        width: 100%;
        height: 100%;
      }
      #root {
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
    `;
    document.head.appendChild(styleElement);

    // Cleanup function
    return () => {
      document.removeEventListener('touchstart', preventZoom);
      document.removeEventListener('touchmove', preventZoom);
      document.removeEventListener('touchend', preventZoom);
      
      // Remove added elements
      document.head.removeChild(metaViewport);
      document.head.removeChild(styleElement);
    };
  }, []);

  return null;
};

export default PreventIOSZoom;